import type { ReactNode } from "react";
import DumaxMark from "../../../../assets/LogoSplash.svg";
import type { SgPlatform } from "../../../features/sg/platforms";
import { PLATFORM_META } from "../../../features/sg/platforms";

// Wialon y Mapon dibujados a mano a partir de sus logos (el símbolo, sin la
// palabra): a 16-24 px el wordmark no se lee y el símbolo sí. Dumax usa su pin
// del repo, recortado: LogoSplash trae ~25 % de margen alrededor del pin.

function WialonMark({ size }: { size: number }) {
  const arc = (a0: number, a1: number) => {
    const r = 36;
    const p = (a: number) => [50 + r * Math.cos((a * Math.PI) / 180), 50 + r * Math.sin((a * Math.PI) / 180)];
    const [x0, y0] = p(a0);
    const [x1, y1] = p(a1);
    return `M${x0.toFixed(1)} ${y0.toFixed(1)} A${r} ${r} 0 0 1 ${x1.toFixed(1)} ${y1.toFixed(1)}`;
  };
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <g fill="none" strokeLinecap="round" strokeWidth={13}>
        <path d={arc(-62, 28)} stroke="#2F8FE8" />
        <path d={arc(58, 172)} stroke="#F2295B" />
        <path d={arc(196, 250)} stroke="#F2295B" />
      </g>
    </svg>
  );
}

function MaponMark({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <path d="M32 66 L20 96 L50 72 Z" fill="#66B300" />
      <circle cx="54" cy="42" r="28" fill="none" stroke="#66B300" strokeWidth={14} />
    </svg>
  );
}

function DumaxPin({ size }: { size: number }) {
  return (
    <span className="inline-block overflow-hidden" style={{ width: size, height: size }} aria-hidden="true">
      <img src={DumaxMark} alt="" className="w-full h-full object-contain scale-[1.9]" />
    </span>
  );
}

export function PlatformLogo({ platform, size = 16 }: { platform: SgPlatform; size?: number }): ReactNode {
  if (platform === "wialon") return <WialonMark size={size} />;
  if (platform === "mapon") return <MaponMark size={size} />;
  return <DumaxPin size={size} />;
}

export function platformLabel(p: string) {
  return PLATFORM_META[p as SgPlatform]?.label ?? p;
}
